import userMemberApi from '@/api/usermember'
import { LIMIT } from '@/helpers/enums'

const userMemberModel = {
  isManager: false,
  isOrgAdmin: false,
  muser: 0,
  morganization: 0
}

const state = {
  newUserMembership: Object.assign({}, userMemberModel),
  editUserMembership: false,

  viewUsersMembershipsPending: false,
  viewUsersMembershipsFailure: false,
  viewUsersMembershipsSuccess: [], // A specific users memberships

  createUserMembershipPending: false,
  createUserMembershipFailure: false,
  createUserMembershipSuccess: false,

  updateUserMembershipPending: false,
  updateUserMembershipFailure: false,
  updateUserMembershipSuccess: false,

  deleteUserMembershipPending: false,
  deleteUserMembershipFailure: false,
  deleteUserMembershipSuccess: false

}

const getters = {
  viewUsersMembershipsPending: state => state.viewUsersMembershipsPending,
  viewUsersMembershipsFailure: state => state.viewUsersMembershipsFailure,
  viewUsersMembershipsSuccess: state => state.viewUsersMembershipsSuccess,

  getCreateUserMembership: state => state.newUserMembership,
  createUserMembershipPending: state => state.createUserMembershipPending,
  createUserMembershipFailure: state => state.createUserMembershipFailure,
  createUserMembershipSuccess: state => state.createUserMembershipSuccess,

  getEditUserMembership: state => state.editUserMembership,
  updateUserMembershipPending: state => state.updateUserMembershipPending,
  updateUserMembershipFailure: state => state.updateUserMembershipFailure,
  updateUserMembershipSuccess: state => state.updateUserMembershipSuccess
}

const _getAllUserMembershipRecords = async (payload, numOfCalls = 1) => {
  const response = await userMemberApi.getUsersMemberships(payload)
  if (response.status !== 200) {
    throw response.body.error
  }

  if (numOfCalls >= LIMIT.NUM_OF_RECURSIVE_CALLS || response.length < LIMIT.FIND) {
    return response.body
  }

  if (!payload.skip) {
    payload.skip = 0
  }
  payload.skip += LIMIT.FIND

  const records = await _getAllUserMembershipRecords(payload, numOfCalls + 1)
  return response.body.concat(records)
}

const actions = {
  async getUsersMembershipRecords ({ commit, state }, payload) {
    commit('SET_USERMEMBER_STATE', { field: 'viewUsersMembershipsPending', value: true })

    try {
      const response = await _getAllUserMembershipRecords(payload)
      commit('SET_USERMEMBER_STATE', { field: 'viewUsersMembershipsSuccess', value: response })
    } catch (error) {
      commit('SET_USERMEMBER_STATE', { field: 'viewUsersMembershipsFailure', value: error })
    }

    commit('SET_USERMEMBER_STATE', { field: 'viewUsersMembershipsPending', value: false })
  },

  async createUserMembership ({ commit, state, dispatch }, payload) {
    commit('SET_USERMEMBER_STATE', { field: 'createUserMembershipPending', value: true })
    if (payload.isDWUser === true) {
      console.log('isDWUser ==== true')
      let dwUserCheck = await userMemberApi.getLicenseUsed(payload)
      if (dwUserCheck.status && dwUserCheck.status !== 200) {
        console.log('dwUser check failed on create')
        console.log(dwUserCheck.body)
        commit('SET_USERMEMBER_STATE', { field: 'createUserMembershipPending', value: false })
        commit('SET_USERMEMBER_STATE', { field: 'createUserMembershipFailure', value: 'All data warehouse seats allocated' })
        return
      }
    }
    let response = await userMemberApi.createUserMembership(payload)

    commit('SET_USERMEMBER_STATE', { field: 'createUserMembershipPending', value: false })

    if (response.status !== 200) {
      // TO DO - Is there always a body.error?
      commit('SET_USERMEMBER_STATE', { field: 'createUserMembershipFailure', value: response.body.error })
      return
    }

    commit('ADD_USERMEMBER_IN_LIST', response.body)
    commit('SET_USERMEMBER_STATE', { field: 'createUserMembershipSuccess', value: response.body })

    const userId = response.body.muser.id
    dispatch('resetUser', userId, { root: true })
  },
  async updateUserMembership ({ commit, state }, payload) {
    commit('SET_USERMEMBER_STATE', { field: 'updateUserMembershipPending', value: true })
    console.log('updateUserMembership')
    console.log(payload)
    if (payload.data.isDWUser === true) {
      console.log('data.isDWUser ==== true')
      let dwUserCheck = await userMemberApi.getLicenseUsed(payload)
      if (dwUserCheck.status && dwUserCheck.status !== 200) {
        console.log('dwUser check failed on update')
        console.log(dwUserCheck.body)
        commit('SET_USERMEMBER_STATE', { field: 'updateUserMembershipPending', value: false })
        commit('SET_USERMEMBER_STATE', { field: 'updateUserMembershipFailure', value: 'All data warehouse seats allocated' })
        return
      }
    }
    let response = await userMemberApi.updateUserMembership(payload)

    commit('SET_USERMEMBER_STATE', { field: 'updateUserMembershipPending', value: false })

    if (response.status !== 200) {
      commit('SET_USERMEMBER_STATE', { field: 'updateUserMembershipFailure', value: response.body })
      return
    }

    commit('ADD_USERMEMBER_IN_LIST', response.body)
    commit('SET_USERMEMBER_STATE', { field: 'updateUserMembershipSuccess', value: response.body })
  },

  async deleteUserMembership ({ commit, state, dispatch }, payload) {
    commit('SET_USERMEMBER_STATE', { field: 'updateUserMembershipPending', value: true })
    console.log('delete payload')
    console.log(payload)
    let response = await userMemberApi.deleteUserMembership(payload)
    commit('SET_USERMEMBER_STATE', { field: 'updateUserMembershipPending', value: false })

    if (response.status !== 200) {
      commit('SET_USERMEMBER_STATE', { field: 'updateUserMembershipFailure', value: response.body })
      return
    }
    commit('DELETE_USERMEMBER_FROM_LIST', response.body)
    commit('SET_USERMEMBER_STATE', { field: 'updateUserMembershipSuccess', value: response.body })
    const userId = response.body.muser.id
    dispatch('resetUser', userId, { root: true })
    // const userOrganizationGroups = _.get(muser, 'userOrganizationGroups', [])
    // if (userOrganizationGroups.length > 0) {
    //   commit('SET_USER_ORGANIZATION_GROUPS', userOrganizationGroups)
    //   commit('SET_USER_MEMBER_GROUPS')
    //   commit('SET_USER_CONTEXT_OPTIONS')
    // }
  }
}

const mutations = {

  RESET_VIEW_MEMBERSHIP (state) {
    state.viewUsersMembershipsSuccess = []
  },
  DELETE_USERMEMBER_FROM_LIST (state, response) {
    const existingIndex = state.viewUsersMembershipsSuccess.findIndex((r) => r.id === response.id)
    if (existingIndex >= 0) {
      state.viewUsersMembershipsSuccess.splice(existingIndex, 1)
    } else {
      console.log('did not find deleted membership record in the membership list')
    }
  },
  ADD_USERMEMBER_IN_LIST (state, response) {
    console.log('add')
    const existingIndex = state.viewUsersMembershipsSuccess.findIndex((r) => r.id === response.id)

    // Update list with the returned record
    if (existingIndex >= 0) {
      state.viewUsersMembershipsSuccess.splice(existingIndex, 1, response)
    } else {
      state.viewUsersMembershipsSuccess.push(response)
      // TO DO - Sort?
    }
  },
  RESET_CREATE_USERMEMBER (state) {
    state.newUserMembership = Object.assign({}, userMemberModel)
    state.createUserMembershipPending = false
    state.createUserMembershipFailure = false
    state.createUserMembershipSuccess = false
  },
  RESET_UPDATE_USERMEMBER (state) {
    state.editUserMembership = false
    state.updateUserMembershipPending = false
    state.updateUserMembershipFailure = false
    state.updateUserMembershipSuccess = false
  },
  SET_USERMEMBER_STATE (state, payload) {
    const { field, value } = payload
    state[field] = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/usermember.js